module.exports = __webpack_public_path__ + "img/new10.4187c1fa.png";